import * as Yup from 'yup';
import { ContactPageForm } from './InitialValue';

// Minimum character requirements for specific text fields
const MIN_SEARCH_CHARS = 3;

export const contactPageValidationSchema = Yup.object<ContactPageForm>({
  // Search has no minimum length requirement
  search: Yup.string().nullable(),
  // These fields must have at least 3 characters when filled
  employeeNumber: Yup.string()
    .min(
      MIN_SEARCH_CHARS,
      `Employee number must be at least ${MIN_SEARCH_CHARS} characters`
    )
    .nullable(),
  employeeName: Yup.string()
    .min(
      MIN_SEARCH_CHARS,
      `Employee name must be at least ${MIN_SEARCH_CHARS} characters`
    )
    .nullable(),
  occupation: Yup.string()
    .min(
      MIN_SEARCH_CHARS,
      `Occupation must be at least ${MIN_SEARCH_CHARS} characters`
    )
    .nullable(),
  email: Yup.string()
    .min(
      MIN_SEARCH_CHARS,
      `Email must be at least ${MIN_SEARCH_CHARS} characters`
    )
    .nullable(),
  mobile: Yup.string()
    .min(
      MIN_SEARCH_CHARS,
      `Mobile must be at least ${MIN_SEARCH_CHARS} characters`
    )
    .nullable(),
  extension: Yup.string()
    .min(
      MIN_SEARCH_CHARS,
      `Extension must be at least ${MIN_SEARCH_CHARS} characters`
    )
    .nullable(),
  workLocation: Yup.string().nullable(),
  department: Yup.string().nullable(),
  departmentType: Yup.string().nullable(),
});

// Validation function for individual fields
export const validateField = (
  fieldName: string,
  value: string
): string | null => {
  if (!value || value.trim().length === 0) {
    return null; // Empty values are allowed
  }
  // Only enforce min length for specific fields
  const fieldsWithMinLength: Record<string, string> = {
    employeeNumber: 'Employee number',
    employeeName: 'Employee name',
    occupation: 'Occupation',
    email: 'Email',
    mobile: 'Mobile',
    extension: 'Extension',
  };

  if (
    fieldsWithMinLength[fieldName] &&
    value.trim().length < MIN_SEARCH_CHARS
  ) {
    const label = fieldsWithMinLength[fieldName];
    return `${label} must be at least ${MIN_SEARCH_CHARS} characters`;
  }

  return null;
};
